import axios from 'axios';
import serialize from 'form-serialize';
import createValidator from '../../modules/validator';
import loadScript from '../../modules/load-script';
import { toFormData } from '../utils/forms';
import { getOffsetTop } from '../utils/dom';
import { insertLeadInMondayFromForm } from './send-to-monday-crm';

function isCalendlyEvent(e: any) {
    return e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf('calendly.') === 0;
}

async function init(container: HTMLElement | Document = document) {
    const form = container.querySelector<HTMLFormElement>('form.js-calendly-form');

    if (form) {
        const firstNameInput = form.querySelector<HTMLInputElement>('input.js-booking-form-input-first-name');
        const lastNameInput = form.querySelector<HTMLInputElement>('input.js-booking-form-input-last-name');
        const emailInput = form.querySelector<HTMLInputElement>('input.js-booking-form-input-email');
        const phoneInput = form.querySelector<HTMLInputElement>('input.js-booking-form-input-phone');

        if (form.dataset.calendlyUrl) {
            await loadScript('https://assets.calendly.com/assets/external/widget.js');
        }

        let currentStep = 1;
        const stepEls = Array.from(form.querySelectorAll<HTMLElement>('.js-settings-company-step'));
        const stepControlEls = Array.from(container.querySelectorAll<HTMLElement>('.js-form-step-control'));
        const errorMessageEl = form.querySelector('.js-form-error');
        const validateFormBtn = form.querySelector<HTMLElement>('.js-validate-form-btn');
        const billingBody = container.querySelector<HTMLElement>('.js-billing-body');
        const bookingFormBody = container.querySelector<HTMLElement>('.js-booking-page-body');
        const calendlyEl = container.querySelector<HTMLElement>('.js-calendly-widget');
        const token = form.dataset.calendlyPersonalToken;

        const validator = createValidator(form, {
            inputSelector: '.js-form-validate-input',
            scrollToInvalidInputOptions: {
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            },
        });

        function setCurrentStep(step: number) {
            stepEls.forEach((el) => {
                el.classList.add('is-hidden');
            });
            stepEls[step - 1]?.classList.remove('is-hidden', 'trial-page-control--completed');

            stepControlEls.forEach((el) => {
                el.classList.remove('is-active');
            });
            stepControlEls[step - 1]?.classList.add('is-active');

            for (let i = 0; i < step - 1; i++) {
                stepControlEls[i].classList.add('trial-page-control--completed');
            }

            setTimeout(() => {
                if (form && form.getBoundingClientRect().top < 0) {
                    window.scrollTo({ top: form.offsetTop - 150, behavior: 'smooth' });
                }
            }, 1);

            if (billingBody) {
                billingBody.hidden = step < 2;
            }

            if (bookingFormBody) {
                bookingFormBody.hidden = step >= 2;
            }
        }

        setCurrentStep(currentStep);

        validateFormBtn?.addEventListener('click', async () => {
            const isFormValid = validator.validate();

            if (isFormValid) {
                currentStep++;
                setCurrentStep(currentStep);

                // if (process.env.NODE_ENV === 'production') {
                //     // send data to Monday
                //     insertLeadInMondayFromForm(form);
                // }

                if (form.dataset.calendlyUrl) {
                    const { Calendly } = window as any;

                    if (Calendly) {
                        form.classList.add('is-loading');

                        if (errorMessageEl) {
                            errorMessageEl.textContent = '';
                        }

                        try {
                            const response = await axios.post(
                                form.getAttribute('action')!,
                                toFormData(serialize(form, { hash: true })),
                            );

                            if (response.data.status === 'success') {
                                if (calendlyEl) {
                                    window.scrollTo({ top: getOffsetTop(calendlyEl) - 40, behavior: 'smooth' });

                                    Calendly.initInlineWidget({
                                        url:
                                            form.dataset.calendlyUrl +
                                            (phoneInput
                                                ? `${
                                                      form.dataset.calendlyUrl.includes('?') ? '&' : '?'
                                                  }location=${phoneInput.value.trim().replace('+', '')}`
                                                : ''),
                                        parentElement: calendlyEl,
                                        prefill: {
                                            name: `${firstNameInput ? firstNameInput.value.trim() : ''} ${
                                                lastNameInput ? lastNameInput.value.trim() : ''
                                            }`.trim(),
                                            email: emailInput ? emailInput.value.trim() : '',
                                            location: phoneInput ? phoneInput.value.trim().replace('+', '') : '',
                                        },
                                        utm: {},
                                    });

                                    window.addEventListener('message', async (event) => {
                                        if (isCalendlyEvent(event) && event.data.event === 'calendly.event_scheduled') {
                                            localStorage.setItem(
                                                'CALENDLY_EMAIL',
                                                emailInput ? emailInput.value.trim() : '',
                                            );
                                            const { data } = await axios.get(event.data.payload.event.uri, {
                                                headers: {
                                                    Authorization: `Bearer ${token}`,
                                                },
                                            });

                                            if (data.resource.start_time) {
                                                localStorage.setItem('CALENDLY_DATE', data.resource.start_time);
                                            }

                                            window.location.href = form.dataset.successRedirectUrl || '';
                                        }
                                    });
                                }
                            } else {
                                if (response.data.data.errors) {
                                    const errors = Array.isArray(response.data.data.errors)
                                        ? response.data.data.errors.join('\n')
                                        : response.data.data.errors;
                                    if (errorMessageEl) {
                                        errorMessageEl.textContent = errors || 'Something went wrong';
                                    }
                                }
                            }
                        } finally {
                            form!.classList.remove('is-loading');
                        }
                    }
                }
            }
        });

        stepControlEls.forEach((btn) => {
            btn.addEventListener('click', () => {
                const index = stepControlEls.indexOf(btn);

                if (index <= currentStep - 1) {
                    setCurrentStep(index + 1);
                }
            });
        });
    }
}

function destroy() {}

export default { init, destroy };
